import { Environment } from '@interfaces/environment.interface';
import { AuthConfig } from 'angular-oauth2-oidc';

import { authConfigDevelopment, authConfigProduction } from './auth.config';

let directusUrl: string;
let authConfig: AuthConfig;
let matomoEnabled = false;
let sentryDsn: string | undefined;

switch (window.location.hostname) {
  case 'staging.pis.wuestenrot.at':
    directusUrl = 'https://wuestenrot.staging.web-punks.com';
    authConfig = authConfigProduction;
    authConfig.showDebugInformation = true;
    matomoEnabled = false;
    sentryDsn = 'https://57872706987933408492113925714174@o4509930494945280.ingest.us.sentry.io/4509930494945280';
    break;
  case 'pis.wuestenrot.at':
    directusUrl = 'https://directus.pis.wuestenrot.at';
    authConfig = authConfigProduction;
    sentryDsn = 'https://57872706987933408492113925714174@o4509930494945280.ingest.us.sentry.io/4509930494945280';
    matomoEnabled = true;
    break;
  default:
    directusUrl = 'https://wuestenrot.staging.web-punks.com';
    authConfig = authConfigDevelopment;
}

export const environment: Environment = {
  authConfig,
  directusUrl,
  matomo: {
    enabled: matomoEnabled,
    siteId: 6,
    trackerUrl: 'https://analytics.pis.wuestenrot.at'
  },
  previewToken: '018d1248-1808-7ee5-83d6-bfbea5080c45',
  production: true,
  sentryDsn,
  version: '1.5.1'
};
